
const AssetName = {
    FILE: 'File',

    MODEL: 'Model',

    SCENE_STATE: 'SceneState',
    SESSION: 'Session',
    TAG: 'Tag',

    PANORAMIC_IMAGE: 'PanoramicImage',
    PANORAMIC_VIDEO: 'PanoramicVideo',

    IMAGE: 'Image',
    AUDIO: 'Audio',
    VIDEO: 'Video',
    DOCUMENT: 'Document',

    VIEWPOINT: 'Viewpoint',
    VIEWPOINT_GROUP: 'ViewpointGroup',

    ENVIRONMENT: 'Environment',
    VOLUME_GROUP: 'VolumeGroup',
    AVATAR: 'Avatar',
    CABLE: 'Cable',
    MODELLER: 'Modeller',
};

module.exports = {
    AssetName
};
